import { CloseOutlined } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import {
  PasswordInput,
  ReferenceInput,
  SelectInput,
  useRefresh,
} from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import CustomButtonSubmit from "../unit/CustomButtonSubmit";
import HmTextInput from "../unit/HmTextInput";
import formatPhone from "../unit/inputFormat/formatPhone";
import parsePhone from "../unit/inputFormat/parsePhone";
import InUseInput from "../unit/InUseInput";
import OneZeroInput from "../unit/OneZeroInput";
import useNotify from "../unit/useNotify";
import CustomDialogTitle from "../unit/CustomDialogTitle";
import { useForm, FormProvider } from "react-hook-form";
const BankerAdd = (props: any) => {
  const refresh = useRefresh();
  const methods = useForm();
  const id = 99999;
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [open, setOpen] = React.useState(false);
  const passwordRuleText =
    "Minimum 8 characters with at least 1 letter, 1 number, and 1 special character";
  const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9\s]).{8,}$/;
  const [passwordValue, setPasswordValue] = React.useState("");
  const [passwordInteracted, setPasswordInteracted] = React.useState(false);

  const passwordRules = {
    minLength: passwordValue.length >= 8,
    hasLetter: /[A-Za-z]/.test(passwordValue),
    hasNumber: /\d/.test(passwordValue),
    hasSpecial: /[^A-Za-z0-9\s]/.test(passwordValue),
  };

  const isPasswordValid = passwordPattern.test(passwordValue);

  const getPasswordRuleColor = (ruleValid: boolean) => {
    if (!passwordInteracted) {
      return "text.secondary";
    }

    return ruleValid ? "success.main" : "error.main";
  };

  const validatePassword = (value: string) => {
    if (!value) {
      return "Password is required";
    }

    if (!passwordPattern.test(value)) {
      // return passwordRuleText; //this is repeat with error message
      return "Invalid password format";
    }

    return undefined;
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    refresh();
  };
  const auth = localStorage.getItem("authrole");

  if (auth != "admin" && auth != "bankadmin") {
    return null;
  }
  return (
    <>
      <Button
        onClick={handleOpen}
        id="dialog-banker-add"
        variant="text"
        color="primary"
        size="small"
        sx={{
          width: "120px",
          minWidth: "120px",
          color: "primary.main",
          "&.MuiButton-sizeSmall": {
            lineHeight: 1.5,
            fontSize: "0.875rem",
          },
        }}
      >
        <AddIcon sx={{ fontSize: "1.25rem" }} /> Member
      </Button>
      <FormProvider {...methods}>
        <Dialog
          id="dialog-banker-add"
          className="bankers_add_dialog"
          open={open}
          onClose={handleClose}
          fullWidth={true}
          maxWidth="lg"
          PaperProps={{
            component: "form",
            onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              let formJson = Object.fromEntries((formData as any).entries());
              if (formJson.sStatus == "on") {
                formJson.sStatus = "Enabled";
              } else {
                formJson.sStatus = "";
              }
              if (formJson.bankadmin == "on") {
                formJson.bankadmin = "1";
              }
              let permission = "";

              const permissionInputs = document.querySelectorAll(
                'input[class^="permission"]'
              );
              permissionInputs.forEach((input) => {
                if ((input as HTMLInputElement).checked) {
                  permission += (input as HTMLInputElement).value + ",";
                }
              });

              interface SaveFormJson {
                bank?: string;
                sFname?: string;
                sLname?: string;
                email?: string;
                mobilephone?: string;
                password?: string;
                sStatus?: string;
                bankadmin?: string;
                permission?: string;
              }

              let saveFormJson: SaveFormJson = {};
              saveFormJson.bank = formJson?.bank;
              saveFormJson.sFname = formJson?.sFname;
              saveFormJson.sLname = formJson?.sLname;
              saveFormJson.email = formJson?.email;
              saveFormJson.mobilephone = formJson?.mobilephone;
              saveFormJson.password = formJson?.password;
              saveFormJson.sStatus = formJson?.sStatus;
              saveFormJson.bankadmin = formJson?.bankadmin;
              saveFormJson.permission = "";

              if (!formJson?.password) {
                errorNotify("Password is required");
                return;
              }

              if (!passwordPattern.test(String(formJson.password))) {
                errorNotify(passwordRuleText);
                return;
              }

              const reqUrl = `bankers/actions/add`;
              const response = await sendRequest(reqUrl, {
                id: "new",
                data: formJson,
              });
              if (response && response.code == "200") {
                successNotify("Data saved successfully");
                handleClose();
              } else {
                errorNotify(response.message);
              }
            },
          }}
        >
          <DialogTitle
            sx={{
              borderBottom: "1px solid #e5e5e5",
              mb: 2,
            }}
          >
            <CustomDialogTitle title={`Add Banker`} />
            <IconButton
              style={{ position: "absolute", right: "10px", top: "10px" }}
              onClick={handleClose}
            >
              <CloseOutlined />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {auth == "admin" && (
              <ReferenceInput source="bank" reference="banks">
                <SelectInput
                  optionValue="sBank"
                  optionText="sBankName"
                  label="Bank"
                  defaultValue="ircceo"
                  variant="outlined"
                  helperText={false}
                />
              </ReferenceInput>
            )}
            <HmTextInput source="sFname" label="First Name" />
            <HmTextInput source="sLname" label="Last Name" />
            <HmTextInput source="sEmail" name="email" label="Email" />
            <HmTextInput
              source="sMobilePhone"
              name="mobilephone"
              label="Mobile"
              format={formatPhone}
              parse={parsePhone}
            />
            <PasswordInput
              variant="outlined"
              source="password"
              label="Password"
              helperText={false}
              validate={validatePassword}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setPasswordValue(event.target.value);
                if (!passwordInteracted) {
                  setPasswordInteracted(true);
                }
              }}
              onBlur={() => {
                setPasswordInteracted(true);
              }}
              sx={{
                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                  borderColor:
                    passwordInteracted && !isPasswordValid
                      ? "error.main"
                      : "success.main",
                },
                "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor:
                      passwordInteracted && !isPasswordValid
                        ? "error.main"
                        : "success.main",
                  },
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor:
                      passwordInteracted && !isPasswordValid
                        ? "error.main"
                        : "success.main",
                  },
                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor:
                      passwordInteracted && !isPasswordValid
                        ? "error.main"
                        : "success.main",
                  },
              }}
            />
            <Typography
              variant="body2"
              sx={{
                mt: 1,
                pl: 0.5,
                whiteSpace: "nowrap",
                overflowX: "auto",
              }}
            >
              <Box
                component="span"
                sx={{
                  color: getPasswordRuleColor(passwordRules.minLength),
                }}
              >
                Minimum 8 characters
              </Box>
              <Box component="span" sx={{ color: "text.secondary", mx: 0.75 }}>
                ,
              </Box>
              <Box
                component="span"
                sx={{
                  color: getPasswordRuleColor(passwordRules.hasLetter),
                }}
              >
                1 letter
              </Box>
              <Box component="span" sx={{ color: "text.secondary", mx: 0.75 }}>
                ,
              </Box>
              <Box
                component="span"
                sx={{
                  color: getPasswordRuleColor(passwordRules.hasNumber),
                }}
              >
                1 number
              </Box>
              <Box component="span" sx={{ color: "text.secondary", mx: 0.75 }}>
                ,
              </Box>
              <Box
                component="span"
                sx={{
                  color: getPasswordRuleColor(passwordRules.hasSpecial),
                }}
              >
                1 special character
              </Box>
            </Typography>
            <InUseInput
              source="sStatus"
              name="sStatus"
              label="Status"
              helperText={false}
            />
            <OneZeroInput
              source="bankadmin"
              name="bankadmin"
              label="Admin"
              helperText={false}
              sx={{ mt: 0 }}
            />
          </DialogContent>
          <DialogActions>
            <CustomButtonSubmit label="Add" />
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export default BankerAdd;
